import { useNavigate } from "react-router-dom"
import Chip from "@mui/material/Chip" 

export default function Banner() {

  const navigate = useNavigate()

  return (
    <section
      className="hero-gradient text-white py-16 md:py-20 lg:py-24 mt-[72px]"
      id="home"
    >
      <div className="container mx-auto px-4 lg:px-8">
        <div className="max-w-6xl">
          <div className="flex items-center justify-between w-full mb-8 md:mb-12">
            <div className="flex items-center">
              <div className="w-1 h-8 bg-red-500 mr-4"></div>
              <span className="text-xl md:text-3xl font-semibold">Our Mission</span>
            </div>
            <Chip
              label="BETA"
              size="small"
              sx={{
                fontWeight: 600,
                backgroundColor: "#ef4444",
                color: "white",
                "&:hover": { backgroundColor: "#dc2626" },
              }}
            />
          </div>
          {/*<h1 className="text-2xl md:text-3xl w-full font-semibold mb-6">Our Vision</h1>*/}

          {/*<h2 className="max-w-4xl text-3xl md:text-5xl lg:text-6xl font-bold mb-8 md:mb-12 !leading-snug">*/}
          {/*  To become the <br />*/}
          {/*  leading young professional commercial developer for{" "}*/}
          {/*  <span className="block md:inline">Higher Education</span>*/}
          {/*</h2>*/}
          <h2 className="max-w-4xl text-2xl md:text-5xl lg:text-6xl font-bold mb-8 md:mb-12 !leading-snug">
            To turn student capstone <br />
            projects into university <br/>
            case studies! <br />

            {/*<span className="block md:inline">industry solutions</span>*/}
          </h2>

          {/*<div className="flex items-center mb-8 md:mb-12">*/}
          {/*  <div className="w-1 h-8 bg-red-500 mr-4"></div>*/}
          {/*  <span className="text-xl md:text-2xl font-medium">We Create Possibility</span>*/}
          {/*</div>*/}

          <div className="flex flex-col sm:flex-row items-start gap-4 md:gap-6">
            <button
              onClick={() => navigate("/projects")}
              className="bg-white text-blue-600 px-6 md:px-8 py-3 md:py-4 rounded-lg font-semibold text-sm md:text-base hover:bg-gray-100 transition-colors duration-300 min-w-[140px] md:min-w-[160px]"
            >
              View Projects
            </button>
            {/* <button className="border-2 border-white text-white px-6 md:px-8 py-3 md:py-4 rounded-lg font-semibold text-sm md:text-base hover:bg-white hover:text-blue-600 transition-all duration-300 min-w-[140px] md:min-w-[160px]">
              Learn More
            </button> */}
          </div>
        </div>
      </div>
    </section>
  );
}
